import {connect} from 'react-redux';

import {toggleAnimation} from 'topmeteo/general/actionCreators';

import BaseControl from './BaseControl';

const Space = props => <BaseControl {...props} catchKey=" " />;

const mapDispatchToProps = dispatch => ({
    handler: () => dispatch(toggleAnimation),
});

export default connect(null, mapDispatchToProps)(Space);
